export default __webpack_public_path__ + "static/media/brit-doubt.98878b47.gif";